var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.is_rb && _vm.adminId != null && _vm.adminId != '' && _vm.adminId != undefined )?_c('div',{staticClass:"box"},[_c('span')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }